module.exports = __webpack_public_path__ + "img/icon-nav-other.6b670e9f.svg";